module.exports = __webpack_public_path__ + "24fea1fd5f86eb1ba2820723b5cfb731.pdf";